import { z } from "zod";

export const inspectionFormSchema = z.object({
  dateOfInspection: z.string().min(1, "Required"),
  inspectionTypeId: z.string().min(1, "Required"),
  placeOfInspection: z.string().min(1, "Required"),
  vesselId: z.string().min(1, "Required"),
});

export type inspectionFormType = z.infer<typeof inspectionFormSchema>;

// Type for individual segment questions
export interface SegmentQuestionInterface {
  name: string;
  question: string;
  questionNumber: number;
  questionType: string;
  id: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  modifiedAt: string; // ISO date string
  createdBy: string | null; // Nullable string
  answer: string | null;
  comment: string | null;
  observations?: string | null;
  value?: string | null;
  CertificatesIssued?: string | null;
  priority: string | null;
  CertificateValidity?: string | null;
  LastEndorsement?: string | null;
  condition?: string | null;
  qty?: string | null;
  recommendation?: string | null;
  fields?:any;

}

// Type for the main segment object
export interface SegmentInterface {
  name: string;
  segmentNumber: number;
  segmentQuestions: SegmentQuestionInterface[];
  id: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  modifiedAt: string; // ISO date string
  createdBy: string | null; // Nullable string
}

export interface PrioritiesInterface {
  id: number;
  name: string;
  value: string;
}

export interface InspectionFormSegmentsInterface {
  question: string;
  questionNumber: number;
  suitabilityStatus: string;
  questionType: string;
  priority: string | number;
  commentsOrFinds: string;
  id?: string;
}

export interface defectCheckListAttachmentsInterface {
  base64Image: "string";
  mimeType: "string";
}

export interface DefectCriteriaInterface {
  comments: string;
  criticalEquipment?: string;
  defectCheckListAttachments: defectCheckListAttachmentsInterface[];
  defectTypeId: string;
  equipmentId: string;
  priority: string;
  defectCheckListAttachmentsList?: any[];
}

export interface ActionTrackerInterface {
  vesselId: string;
  equipmentName: string;
  equipmentId: string;
  criticalEquipment: string;
  defectTypeId: string;
  marineSuperintendentId: string;
  comments: string;
  priority: string;
  responsibleParty: string;
  resourcesNeeded: string;
  targetCloseOutDate: string; // ISO date string,
  dateClosed: string; // ISO date string,
  descriptionOfDefect: string;
  percentageOfActionClosedOut: string;
  defectCheckListAttachments: {
    base64Image: string;
    mimeType: string;
  }[];
  defaultDefectCheckListAttachments?: {
    base64Image: string;
    mimeType: string;
  }[];
}

export const ActionTrackerSchema = z.object({
  vesselId: z.string(),
  equipmentId: z.string(),
  criticalEquipment: z.string(),
  defectTypeId: z.string(),
  marineSuperintendentId: z.string(),
  priority: z.string(),
  responsibleParty: z.string(),
  resourcesNeeded: z.string(),
  targetCloseOutDate: z.string().refine((val) => !isNaN(Date.parse(val)), {
    message: "Invalid ISO date string",
  }),
  // dateClosed: z
  //   .union([
  //     z.string().refine((val) => !isNaN(Date.parse(val)), {
  //       message: "Invalid ISO date string",
  //     }),
  //     z.literal(""),
  //   ])
  //   .optional(),
  descriptionOfDefect: z.string(),
  comments: z.string(),
  percentageOfActionClosedOut: z.string(),
  defectCheckListAttachments: z.array(
    z.object({
      base64Image: z.string(),
      mimeType: z.string(),
    })
  ),
});
